import axios from "axios";

export function getTransferDeliveryInfo(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/transfer/${uuid}/delivery-info`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
